import React from 'react';
import type { PaginationInfo } from '../../../types';
import PageSizeSelect from '../PageSizeSelect/PageSizeSelect';
import Pagination from '../Pagination/Pagination';
import styles from './ListingBottomRow.module.css';

interface ListingBottomRowProps {
  pageSize: number;
  pageSizeOptions: readonly number[];
  onPageSizeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  pagination: PaginationInfo;
  loading: boolean;
  onPageChange: (page: number) => void;
}

const ListingBottomRow: React.FC<ListingBottomRowProps> = ({
  pageSize,
  pageSizeOptions,
  onPageSizeChange,
  pagination,
  loading,
  onPageChange,
}) => (
  <div className={styles['bottom-row']}>
    <PageSizeSelect
      value={pageSize}
      options={pageSizeOptions}
      onChange={onPageSizeChange}
    />
    <div className={styles['pagination-center']}>
      <Pagination
        pagination={pagination}
        loading={loading}
        onPageChange={onPageChange}
      />
    </div>
  </div>
);

export default ListingBottomRow;
